<template>
  <div class='sub-page' style='width:100%!important;margin:0 auto;border:0px solid gray;overflow:hidden;padding-top:60px;'>
    <div class="header">
      <h3>종합지표</h3>
    </div>
    <div class='bars' style="padding-top:5px;">
      <div class='left-bar'>
        <div class="float-left" style="color:rgb(92, 92, 92)">
          <div class="caption">일매출현황(천원)</div>
          <div class="line">
            <div class="parameters-day" v-for='(item, index)  in filteredParametersDay' :key="index">
                <div class="parameter-name">{{ item.salesDate|MMdd }}</div>
                <div class="parameter" >{{ Math.round(item.salesAmount/1000)|comma }}</div>
            </div>
          </div>
        </div>
        <div class="float-left" style="margin-left:10px;color:rgb(92, 92, 92)">
          <div class="caption">일생산현황(천원)</div>
          <div class="line">
            <div class="parameters-day" v-for='(item, index)  in filteredParametersDay' :key="index">
                <div class="parameter-name">{{ item.salesDate|MMdd }}</div>
                <div class="parameter" >{{ Math.round(item.productAmount/1000)|comma }}</div>
            </div>
          </div>
        </div>
        <div class="switcher float-left" style="margin-top: 15px;">
          <div class="switcher">
              <span class="dx-icon-spinright icon" v-bind:class="{ disabled: latestDate === date }" @click="update(1)"></span>
              <span class="dx-icon-spinleft icon"  @click="update(-1)"></span>
              <span class="date">{{ date|yyyyMMdd }}</span>
          </div>
        </div>
        <div class="chart">
          <DxChart
            id="chart"
            :data-source="dataSource"
            :customizePoint="customizePointDaily"
          >
            <DxSize :height="215"></DxSize>
            <DxCommonSeriesSettings
              argument-field="headName"
              type="bar"
              hover-mode="onlyPoint"
              selection-mode="onlyPoint"
              :minBarSize="5"
            >
              <DxLabel :visible="false">
                <DxFormat
                  :precision="0"
                  type="fixedPoint"
                />
              </DxLabel>
            </DxCommonSeriesSettings>
            <DxLegend :visible="false"></DxLegend>
            <DxArgumentAxis :visible="false">
              <DxLabel :customizeText="customizeArgumentLabel"></DxLabel>
              <DxTick :visible="false"></DxTick>
            </DxArgumentAxis>
            <DxTooltip :enabled="true" borderColor="#d9d9d9" color="#fff"
              :paddingTopBottom="8" :customizeTooltip="customizeTooltipDay" :format="tooltipFormatDay">
              <DxFont :opacity="1" :size="22"></DxFont>
              <DxShadow :opacity="0.15" :blur="0" :offsetX="3" :offsetY="3" color="#000"></DxShadow>
            </DxTooltip>
            <DxValueAxis :axisDivisionFactor="40" :placeholderSize="45" :max="maxAxisValueDay" :visible="false">
                <DxLabel :format="format" :customizeText="customizeValueLabel"></DxLabel>
                <DxTick :visible="false"></DxTick>
            </DxValueAxis>
            <DxSeries valueField="yesterday2Amount" :name='yesterdayName2|MMdd' color="rgba(175, 175, 175, 0.45)" :bar-width="barWidth">
                <DxHoverStyle color="rgba(175, 175, 175, 0.45)">
                    <DxHatching :opacity="0"></DxHatching>
                </DxHoverStyle>
            </DxSeries>
            <DxSeries valueField="yesterdayAmount" :name='yesterdayName|MMdd' color="rgba(175, 175, 175, 0.45)" :bar-width="barWidth">
                <DxHoverStyle color="rgba(175, 175, 175, 0.45)">
                    <DxHatching :opacity="0"></DxHatching>
                </DxHoverStyle>
            </DxSeries>
            <DxSeries valueField="todayAmount" :name='todayName|MMdd' :bar-width="barWidth"></DxSeries>
          </DxChart>
        </div>
      </div>
      <div class='right-bar'>
        <div class="float-left" style="color:rgb(92, 92, 92)">
          <div class="caption">월매출현황(천원)</div>
          <div class="line">
            <div class="parameters" v-for='(item, index)  in filteredParametersMonth' :key="index">
                <div class="parameter-name">{{ item.salesDate|yyyyMM }}</div>
                <div class="parameter" >{{ Math.round(item.salesAmount/1000)|comma }}</div>
            </div>
          </div>
        </div>
        <div class="float-left" style="margin-left:10px;color:rgb(92, 92, 92);">
          <div class="caption">월생산현황(천원)</div>
          <div class="line">
            <div class="parameters" v-for='(item, index)  in filteredParametersMonth' :key="index">
                <div class="parameter-name">{{ item.salesDate|yyyyMM }}</div>
                <div class="parameter" >{{ Math.round(item.productAmount/1000)|comma }}</div>
            </div>
          </div>
        </div>
        <div class="switcher float-left" style="margin-top: 15px;">
          <div class="switcher">
              <span class="dx-icon-spinright icon" v-bind:class="{ disabled: latestMonth === month }" @click="updateMonth(1)"></span>
              <span class="dx-icon-spinleft icon"  v-bind:class="{ disabled: limitMonth === month }" @click="updateMonth(-1)"></span>
              <span class="date">{{ month|yyyyMM }}</span>
          </div>
        </div>
        <div class="chart">
          <DxChart
            id="chart"
            :data-source="dataSourceMonth"
            :customizePoint="customizePointMonth"
          >
            <DxSize :height="215"></DxSize>
            <DxCommonSeriesSettings
              argument-field="headName"
              type="bar"
              hover-mode="onlyPoint"
              selection-mode="onlyPoint"
              :minBarSize="5"
            >
              <DxLabel :visible="false">
                <DxFormat
                  :precision="0"
                  type="fixedPoint"
                />
              </DxLabel>
            </DxCommonSeriesSettings>
            <DxLegend :visible="false"></DxLegend>
            <DxArgumentAxis :visible="false">
              <DxLabel :customizeText="customizeArgumentLabel"></DxLabel>
              <DxTick :visible="false"></DxTick>
            </DxArgumentAxis>
            <DxTooltip :enabled="true" borderColor="#d9d9d9" color="#fff"
              :paddingTopBottom="8" :customizeTooltip="customizeTooltipDay" :format="tooltipFormatDay">
              <DxFont :opacity="1" :size="22"></DxFont>
              <DxShadow :opacity="0.15" :blur="0" :offsetX="3" :offsetY="3" color="#000"></DxShadow>
            </DxTooltip>
            <DxValueAxis :axisDivisionFactor="40" :placeholderSize="45" :max="maxAxisValueMonth" :visible="false">
                <DxLabel  :customizeText="customizeValueLabel"></DxLabel>
                <DxTick :visible="false"></DxTick>
            </DxValueAxis>
            <DxSeries valueField="yesterday2Amount" :name='lastMonth2Name|yyyyMM' color="rgba(175, 175, 175, 0.45)" :bar-width="barWidth">
                <DxHoverStyle color="rgba(175, 175, 175, 0.45)">
                    <DxHatching :opacity="0"></DxHatching>
                </DxHoverStyle>
            </DxSeries>
            <DxSeries valueField="yesterdayAmount" :name='lastMonthName|yyyyMM' color="rgba(175, 175, 175, 0.45)" :bar-width="barWidth">
                <DxHoverStyle color="rgba(175, 175, 175, 0.45)">
                    <DxHatching :opacity="0"></DxHatching>
                </DxHoverStyle>
            </DxSeries>
            <DxSeries valueField="todayAmount" :name='thisMonthName|yyyyMM' :bar-width="barWidth"></DxSeries>
          </DxChart>
        </div>
      </div>
    </div>
    <!-- ************************* ********************************* -->
    <!-- ********************* 년 판매/생산 현황 *********************** -->
    <!-- ************************* ********************************* -->
    <div class="gray-wrap" style="margin: 0 auto; width: 1604px">
      <div class="gray-line" style="margin-right: 0px">
        <div class="title">{{currentYear}}년 매출현황({{Math.round(yearSummary/1000)|comma}}천원)</div>
        <div class="sales-by-range">
          <div class="doughnut-container">
            <DxPieChart class='dx-pie-chart'
                type="doughnut"
                :innerRadius="0.65"
                :dataSource="pieDataSource"
                :minDiameter="0.7"
                :palette='barColor'
                centerTemplate="centerTemplate"
            >
                <DxLoadingIndicator text=""></DxLoadingIndicator>
                <DxLegend :visible="false"
                  :column-count="6"
                  orientation="horizontal"
                  item-text-position="right"
                  horizontal-alignment="center"
                  vertical-alignment="bottom"
                />
                <DxSeries argumentField="headName" valueField="amount">
                  <DxPieLabel :visible="true" backgroundColor="transparent"
                    :radialOffset="-20" :customizeText="customizeLabel">
                      <DxFont :size="12" color="#909090"></DxFont>
                      <DxConnector :visible="false" :width="1"></DxConnector>
                  </DxPieLabel>
                </DxSeries>
                <DxPieSize :height="190" />
                <template #centerTemplate>
                  <svg>
                    <text text-anchor="middle" style="font-size: 14px" x="100" y="120" attr.fill="black" opacity="0.6">
                        <tspan x="100">고객사별 매출</tspan>
                        <tspan x="100" dy="20px">점유율</tspan>
                    </text>
                  </svg>
                </template>

            </DxPieChart>
          </div>
          <div class="bar-container">
            <DxChart class='dx-chart'
                :rotated="true"
                :dataSource="pieDataSource"
                :customizePoint="customizePointYear"
            >
                <dx-argument-axis :placeholderSize="100" :visible="true">
                    <dx-label :visible="true"></dx-label>
                    <dx-tick :visible="false"></dx-tick>
                </dx-argument-axis>
                <dx-value-axis :valueMarginsEnabled="false" :axisDivisionFactor="80" :placeholderSize="30" :visible="false">
                  <dx-label :indentFromAxis="5">
                      <dx-format type="millions"></dx-format>
                      <dx-font :opacity="0.6"></dx-font>
                  </dx-label>
                  <dx-tick :visible="false"/>
                </dx-value-axis>
                <dx-common-series-settings argumentField="headName" valueField="amount" :ignoreEmptyPoints="true" type="bar">
                    <dx-hover-style>
                        <dx-hatching :opacity="0"></dx-hatching>
                    </dx-hover-style>
                </dx-common-series-settings>
                <dx-series-template nameField="headName"></dx-series-template>
                <dx-legend :visible="false"></dx-legend>
                <dx-tooltip :enabled="true" color="#fff" :paddingTopBottom="8" :customizeTooltip="customizeTooltipHbar">
                    <dx-font :opacity="1" size="22"></dx-font>
                    <dx-shadow color="#000" :opacity="0.15" :blur="0" :offsetX="3" :offsetY="3"></dx-shadow>
                </dx-tooltip>
            </DxChart>
          </div>
        </div>
        <!-- 년매출 레인지-->
        <div class="range-selector">
          <div class="container">
            <div class="dx-icon-chevronleft icon" v-bind:class="{ disabled: currentYear === 2019 }" @click="changeYearSales(-1)"></div>
            <dx-range-selector
              selectedRangeColor="rgba(0,0,0,0)"
              :dataSource="rangeDataSource"
              @value-changed="rangeChange($event)"
            >
              <dx-behavior :animationEnabled="true"></dx-behavior>
              <dx-loading-indicator backgroundColor="rgba(0,0,0,0)"></dx-loading-indicator>
              <dx-indent :right="34" :left="34"></dx-indent>
              <dx-size :height="90"></dx-size>
              <dx-slider-marker :visible='true' color='rgb(218,89,89' format="monthAndDay"></dx-slider-marker>
              <dx-slider-handle :opacity="0.1"></dx-slider-handle>
              <DxRangeChart>
                  <DxRangeSeries type="line" :opacity="0.8" argumentField="salesDate" valueField="sales"
                    color="rgb(218,89,89)"
                  >
                      <dx-point :visible="false"></dx-point>
                  </DxRangeSeries>
              </DxRangeChart>
              <dx-scale tickInterval="month" minorTickInterval="day" valueType="datetime">
                <dx-marker :visible="false"></dx-marker>
                <dx-minor-tick :visible="false"></dx-minor-tick>
                <dx-tick :opacity="0.1"></dx-tick>
                <DxRangeLabel>
                    <dx-font :opacity="0.6"></dx-font>
                </DxRangeLabel>
              </dx-scale>
              <dx-shutter :color="shutterColor" :opacity="0.75"></dx-shutter>
            </dx-range-selector>
            <div class="dx-icon-chevronright icon" v-bind:class="{ disabled: currentYear === thisYear }" @click="changeYearSales(1)"></div>
          </div>
        </div>
      </div>
      <div class="gray-line">
        <div class="title">{{currentYearProduct}}년 생산현황({{Math.round(yearSummaryProduct/1000)|comma}}천원)</div>
        <div class="sales-by-range">
          <div class="doughnut-container">
            <DxPieChart class='dx-pie-chart'
                type="doughnut"
                :innerRadius="0.65"
                :dataSource="pieDataSourceProduct"
                :minDiameter="0.7"
                :palette='barColor2'
                centerTemplate="centerTemplate"
            >
                <DxLoadingIndicator text=""></DxLoadingIndicator>
                <DxLegend :visible="false"
                  :column-count="6"
                  orientation="horizontal"
                  item-text-position="right"
                  horizontal-alignment="center"
                  vertical-alignment="bottom"
                />
                <DxSeries argumentField="headName" valueField="amount">
                  <DxPieLabel :visible="true" backgroundColor="transparent"
                    :radialOffset="-20" :customizeText="customizeLabel">
                      <DxFont :size="12" color="#909090"></DxFont>
                      <DxConnector :visible="false" :width="1"></DxConnector>
                  </DxPieLabel>
                </DxSeries>
                <DxPieSize :height="190" />
                <template #centerTemplate>
                  <svg>
                    <text text-anchor="middle" style="font-size: 14px" x="100" y="120" attr.fill="black" opacity="0.6">
                        <tspan x="100">고객사별 생산</tspan>
                        <tspan x="100" dy="20px">점유율</tspan>
                    </text>
                  </svg>
                </template>

            </DxPieChart>
          </div>
          <div class="bar-container">
            <DxChart class='dx-chart'
                :rotated="true"
                :dataSource="pieDataSourceProduct"
                :customizePoint="customizeProductPointYear"
            >
                <dx-argument-axis :placeholderSize="100" :visible="true">
                    <dx-label :visible="true"></dx-label>
                    <dx-tick :visible="false"></dx-tick>
                </dx-argument-axis>
                <dx-value-axis :valueMarginsEnabled="false" :axisDivisionFactor="80" :placeholderSize="30" :visible="false">
                  <dx-label :indentFromAxis="5">
                      <dx-format type="millions"></dx-format>
                      <dx-font :opacity="0.6"></dx-font>
                  </dx-label>
                  <dx-tick :visible="false"/>
                </dx-value-axis>
                <dx-common-series-settings argumentField="headName" valueField="amount" :ignoreEmptyPoints="true" type="bar">
                    <dx-hover-style>
                        <dx-hatching :opacity="0"></dx-hatching>
                    </dx-hover-style>
                </dx-common-series-settings>
                <dx-series-template nameField="headName"></dx-series-template>
                <dx-legend :visible="false"></dx-legend>
                <dx-tooltip :enabled="true" color="#fff" :paddingTopBottom="8" :customizeTooltip="customizeTooltipHbar">
                    <dx-font :opacity="1" size="22"></dx-font>
                    <dx-shadow color="#000" :opacity="0.15" :blur="0" :offsetX="3" :offsetY="3"></dx-shadow>
                </dx-tooltip>
            </DxChart>
          </div>
        </div>
         <!-- 년생산 레인지-->
        <div class="range-selector">
          <div class="container">
            <div class="dx-icon-chevronleft icon" v-bind:class="{ disabled: currentYearProduct === 2019 }" @click="changeYearProduct(-1)"></div>
            <dx-range-selector
              selectedRangeColor="rgba(0,0,0,0)"
              :dataSource="rangeDataSourceProduct"
              @value-changed="rangeChangeProduct($event)"
            >
              <dx-behavior :animationEnabled="true"></dx-behavior>
              <dx-loading-indicator backgroundColor="rgba(0,0,0,0)"></dx-loading-indicator>
              <dx-indent :right="34" :left="34"></dx-indent>
              <dx-size :height="90"></dx-size>
              <dx-slider-marker :visible='true' color='rgb(218,89,89' format="monthAndDay"></dx-slider-marker>
              <dx-slider-handle :opacity="0.1"></dx-slider-handle>
              <DxRangeChart>
                  <DxRangeSeries type="line" :opacity="0.8" argumentField="salesDate" valueField="amount"
                    color="rgb(218,89,89)"
                  >
                      <dx-point :visible="false"></dx-point>
                  </DxRangeSeries>
              </DxRangeChart>
              <dx-scale tickInterval="month" minorTickInterval="day" valueType="datetime">
                <dx-marker :visible="false"></dx-marker>
                <dx-minor-tick :visible="false"></dx-minor-tick>
                <dx-tick :opacity="0.1"></dx-tick>
                <DxRangeLabel>
                    <dx-font :opacity="0.6"></dx-font>
                </DxRangeLabel>
              </dx-scale>
              <dx-shutter :color="shutterColor" :opacity="0.75"></dx-shutter>
            </dx-range-selector>
            <div class="dx-icon-chevronright icon" v-bind:class="{ disabled: currentYearProduct === thisYear }" @click="changeYearProduct(1)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLib from '../../share/AppLib'
import ConstDef from '../../share/ConstDef'
import axios from 'axios'
import DxChart, {
  DxSize,
  DxCommonSeriesSettings,
  DxLabel,
  DxFormat,
  DxLegend,
  DxArgumentAxis,
  DxTick,
  DxTooltip,
  DxFont,
  DxShadow,
  DxValueAxis,
  DxSeries,
  DxHoverStyle,
  DxHatching,
  DxSeriesTemplate,
  DxPoint

} from 'devextreme-vue/chart'
import DxPieChart, {
  DxLoadingIndicator,
  DxSize as DxPieSize,
  DxConnector,
  DxLabel as DxPieLabel
} from 'devextreme-vue/pie-chart'

import {
  DxRangeSelector,
  DxScale,
  DxMinorTick,
  DxSliderMarker,
  DxShutter,
  DxMarker,
  DxBehavior,
  DxIndent,
  DxSliderHandle,
  DxLabel as DxRangeLabel,
  DxChart as DxRangeChart,
  DxSeries as DxRangeSeries
} from 'devextreme-vue/range-selector'
import { get } from 'vuex-pathify'

export default {
  name: 'dashboard',
  data: function () {
    return {
      barWidth: 40,
      userInfo: null,
      filteredParametersDay: null,
      filteredParametersMonth: null,
      latestDate: AppLib.getTimestampFromString('2022-03-03 00:00:00'),
      latestMonth: null,
      limitMonth: null,
      date: AppLib.getTimestampFromString('2022-03-03 00:00:00'),
      month: null,
      todayName: '2022-03-03 00:00:00',
      yesterdayName: '2022-03-02',
      yesterdayName2: '2022-03-01', // 2일전
      thisMonthName: null,
      lastMonthName: null,
      lastMonth2Name: null,
      dataSource: null,
      dataSourceMonth: null,
      tooltipFormatDay: '',
      maxAxisValueDay: 2000000,
      maxAxisValueMonth: 800000,
      format: 'millions',
      // color: rgb(248, 115, 62);   color: rgb(57, 133, 248)
      barColorDaily: ['rgb(218,89,89)', 'rgb(240,151,119)'],
      barColor: ['rgb(218,89,89)', 'rgb(240,151,119)', 'rgb(251,201,134)', 'rgb(165,215,208)', 'rgb(165,189,215)', 'rgb(233,124,130)'],
      barColor2: ['rgb(218,89,89)', 'rgb(240,151,119)', 'rgb(251,201,134)', 'rgb(165,215,208)', 'rgb(165,189,215)', 'rgb(233,124,130)'],
      index: 0,
      indexMonth: 0,
      indexYear: 0,
      pieDataSource: null,
      // range bar
      thisYear: new Date().getFullYear(),
      currentYear: new Date().getFullYear(),
      currentYearProduct: new Date().getFullYear(),
      rangeDataSource: null,
      shutterColor: 'rgb(244, 244, 244)',
      modeCount: 6,
      yearSummary: 10000,
      pieDataSourceProduct: null,
      rangeDataSourceProduct: null,
      isInitSalesRange: true,
      isInitProductRange: true,
      indexYearProduct: 0,
      yearSummaryProduct: 0
    }
  },
  components: {
    DxChart,
    DxSize,
    DxCommonSeriesSettings,
    DxLabel,
    DxFormat,
    DxLegend,
    DxArgumentAxis,
    DxTick,
    DxTooltip,
    DxFont,
    DxShadow,
    DxValueAxis,
    DxSeries,
    DxHoverStyle,
    DxHatching,
    DxPieChart,
    DxLoadingIndicator,
    DxConnector,
    DxPieLabel,
    DxSeriesTemplate,
    DxRangeSelector,
    DxScale,
    DxMinorTick,
    DxSliderMarker,
    DxShutter,
    DxMarker,
    DxBehavior,
    DxIndent,
    DxSliderHandle,
    DxPoint,
    DxRangeLabel,
    DxRangeChart,
    DxRangeSeries,
    DxPieSize
  },
  computed: {
    getUserInfoxx: get('getUserInfo')
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    console.log(this.getUserInfoxx)
    this.limitMonth = AppLib.getTimestampFromString('2022-01-31 00:00:00')
    this.initData()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    checkDailyData (dailyList, toDate) {
      for (let i = 0; i < 3; i++) {
        const searchDate = AppLib.calcDateFromFormat(toDate, i * -1)
        if (this.$_.findWhere(dailyList, { salesDate: searchDate }) === undefined) {
          const param = {
            salesDate: searchDate,
            salesAmount: 0,
            productAmount: 0
          }
          dailyList.unshift(param)
        }
      }
      this.filteredParametersDay = this.$_.sortBy(dailyList, 'salesDate')
    },
    checkMonthData (monthList, toMonth) {
      let temp = toMonth
      for (let i = 0; i < 3; i++) {
        temp = `${temp.substring(0, 7)}-01`
        // console.log(temp)
        temp = AppLib.calcDateFromFormat(temp, i * -1).substring(0, 7) + '-01'
        // console.log(temp)
        if (this.$_.findWhere(monthList, { salesDate: temp }) === undefined) {
          const param = {
            salesDate: temp,
            salesAmount: 0,
            productAmount: 0
          }
          monthList.unshift(param)
        }
      }
      this.filteredParametersMonth = this.$_.sortBy(monthList, 'salesDate')
      // console.log(this.filteredParametersMonth)
    },
    initData () {
      this.date = this.latestDate = AppLib.calcDateFromToday(-1)
      let days = AppLib.getMonthLastDay(this.date.substring(0, 4), this.date.substring(5, 7))
      this.latestMonth = this.month = `${this.date.substring(0, 7)}-${days}`
      this.findDailySummary(this.date)
      this.findMonthSummary(this.month)

      const param = {
        fromDate: `${this.thisYear}-01-01`,
        toDate: `${this.thisYear}-12-31 23:59:59`
      }
      this.findYearSalesDailySummary(param)
      this.findYearProductDailySummary(param)
    },
    findDailySummary (searchDate) {
      let all = this.$_sp.runNoEncodeFindProc('spFindAllDashboardLatestSalesAmountByDate', { toDate: searchDate })
      let head = this.$_sp.runNoEncodeFindProc('spFindAllDashboardSalesAmountByDateGbyDate', { toDate: searchDate })
      axios.all([all, head])
        .then(axios.spread((...reponse) => {
          this.todayName = searchDate
          this.yesterdayName = AppLib.calcDateFromFormat(searchDate, -1)
          this.yesterdayName2 = AppLib.calcDateFromFormat(searchDate, -2)
          this.checkDailyData(this.$_sp.MakeModel(reponse[0]), searchDate)
          this.dataSource = this.$_sp.MakeModel(reponse[1])
          // console.log(this.dataSource)
          this.modeCount = this.dataSource.length
          let maxAmount = []
          maxAmount.push(this.$_.max(this.dataSource, function (amount) { return amount.todayAmount }).todayAmount)
          maxAmount.push(this.$_.max(this.dataSource, function (amount) { return amount.yesterdayAmount }).yesterdayAmount)
          maxAmount.push(this.$_.max(this.dataSource, function (amount) { return amount.yesterday2Amount }).yesterday2Amount)
          this.maxAxisValueDay = this.$_.max(maxAmount, function (amount) { return amount }) * 1.2
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    findMonthSummary (searchLastDateOfMonth) {
      // console.log(searchLastDateOfMonth)
      let param = {
        toDate: searchLastDateOfMonth
      }
      // console.log(searchLastDateOfMonth)
      let all = this.$_sp.runNoEncodeFindProc('spFindAllDashboardLatestSalesAmountByMonth', param)
      let head = this.$_sp.runNoEncodeFindProc('spFindAllDashboardSalesAmountByMonthGbyMonth', param)
      axios.all([all, head])
        .then(axios.spread((...reponse) => {
          this.thisMonthName = searchLastDateOfMonth
          this.lastMonthName = AppLib.calcDateFromFormat(this.thisMonthName, -32)
          this.lastMonth2Name = AppLib.calcDateFromFormat(this.thisMonthName, -64)
          this.checkMonthData(this.$_sp.MakeModel(reponse[0]), searchLastDateOfMonth)
          this.dataSourceMonth = this.$_sp.MakeModel(reponse[1])
          let maxAmount = []
          maxAmount.push(this.$_.max(this.dataSourceMonth, function (amount) { return amount.todayAmount }).todayAmount)
          maxAmount.push(this.$_.max(this.dataSourceMonth, function (amount) { return amount.yesterdayAmount }).yesterdayAmount)
          maxAmount.push(this.$_.max(this.dataSourceMonth, function (amount) { return amount.yesterday2Amount }).yesterday2Amount)
          this.maxAxisValueMonth = this.$_.max(maxAmount, function (amount) { return amount }) * 1.1
        }))
        .catch(error => {
          this.isLoading = false
          // // // console.log(error)
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    findYearSalesDailySummary (param) {
      let all = this.$_sp.runNoEncodeFindProc('spFindAllDashboardSalesAmountByYear', param)
      let head = this.$_sp.runNoEncodeFindProc('spFindAllDashboardSalesAmountByYearGbyDate', param)
      axios.all([all, head])
        .then(axios.spread((...reponse) => {
          this.pieDataSource = this.$_sp.MakeModel(reponse[0])
          console.log(this.pieDataSource)
          this.rangeDataSource = this.$_sp.MakeModel(reponse[1])
          this.yearSummary = 0
          for (let i = 0; i < this.pieDataSource.length; i++) {
            this.yearSummary += this.pieDataSource[i].amount
          }
          // console.log(this.yearSummary)
        }))
        .catch(error => {
          this.isLoading = false
          // // // console.log(error)
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    findYearProductDailySummary (param) {
      let all = this.$_sp.runNoEncodeFindProc('spFindAllDashboardProductAmountByYear', param)
      let head = this.$_sp.runNoEncodeFindProc('spFindAllDashboardProductAmountByYearGbyDate', param)
      axios.all([all, head])
        .then(axios.spread((...reponse) => {
          this.pieDataSourceProduct = this.$_sp.MakeModel(reponse[0])
          this.rangeDataSourceProduct = this.$_sp.MakeModel(reponse[1])
          this.yearSummaryProduct = 0
          for (let i = 0; i < this.pieDataSourceProduct.length; i++) {
            this.yearSummaryProduct += this.pieDataSourceProduct[i].amount
          }
        }))
        .catch(error => {
          this.isLoading = false
          // // // console.log(error)
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    customizePointDaily (info) {
      let date = this.todayName
      let mm = parseInt(date.substring(5, 7))
      let dd = parseInt(date.substring(8, 10))
      date = `${mm}월 ${dd}일`

      if (info.seriesName !== date) {
        return
      }
      const value = this.index % this.modeCount
      info.colorIndex = value
      this.index++
      return {
        color: this.barColorDaily[value],
        hoverStyle: {
          color: this.barColorDaily[value],
          hatching: {
            opacity: 0
          }
        }
      }
    },
    customizePointMonth (info) {
      let month = this.latestMonth
      let year = month.substring(0, 4)
      let mm = parseInt(month.substring(5, 7))
      month = `${year}년 ${mm}월`

      if (info.seriesName !== month) {
        return
      }

      const value = this.indexMonth % this.modeCount
      info.colorIndex = value
      this.indexMonth++
      return {
        color: this.barColorDaily[value],
        hoverStyle: {
          color: this.barColorDaily[value],
          hatching: {
            opacity: 0
          }
        }
      }
    },
    customizePointYear (info) {
      const value = this.indexYear % 6
      // info.colorIndex = value
      this.indexYear++
      // console.log(this.barColor[value])
      return {
        color: this.barColor[value],
        hoverStyle: {
          color: this.barColor[value],
          hatching: {
            opacity: 0
          }
        }
      }
    },
    customizeProductPointYear (info) {
      const value = this.indexYearProduct % 6
      // info.colorIndex = value
      this.indexYearProduct++
      // // console.log(this.barColor2[value])
      return {
        color: this.barColor2[value],
        hoverStyle: {
          color: this.barColor2[value],
          hatching: {
            opacity: 0
          }
        }
      }
    },
    customizeTooltipDay (pointInfo) {
      // console.log(pointInfo)
      let color = this.$_.findIndex(this.dataSource, { Criteria: pointInfo.argument })
      color = this.barColor[color]
      let value = parseInt(pointInfo.valueText)
      value = AppLib.comma((value / 1000).toFixed(0))
      return {
        text: '<span style="font-size: 14px; color: #808080;">' + pointInfo.argumentText.toUpperCase() + '</span><br />' +
                '<span style="color: ' + color + '">' + value + '</span><br />' +
                '<span style="font-size: 14px; color: #808080;">' + pointInfo.seriesName + '</span>'
      }
    },
    customizeValueLabel (pointInfo) {
      if (pointInfo.value < pointInfo.max) {
        return pointInfo.valueText
      }
      return ''
    },
    getMaxAxisValue () {
      return 400000
    },
    customizeArgumentLabel (pointInfo) {
      return this.getShortFieldName(pointInfo.value)
    },
    getShortFieldName (fieldName) {
      const replaceTable = {
        Manufacturing: 'Manuf.',
        'Eco Supreme': 'Eco Supr.',
        'EnviroCare Max': 'Enviro Max'
      }
      return replaceTable[fieldName] || fieldName
    },
    update (day) {
      let calcDate = AppLib.calcDateFromFormat(this.date, day)
      if (this.latestDate < calcDate) {
        return
      }
      this.date = calcDate
      this.findDailySummary(AppLib.formatDateFromTimeStamp(this.date))
    },
    updateMonth (month) {
      let temp = AppLib.formatDateFromTimeStamp(this.month)
      if (month > 0) {
        temp = AppLib.calcDateFromFormat(temp, month)
        let days = AppLib.getMonthLastDay(temp.substring(0, 4), temp.substring(5, 7))
        temp = `${temp.substring(0, 7)}-${days}`
      } else {
        temp = AppLib.calcDateFromFormat(`${temp.substring(0, 7)}-01`, month)
      }
      let timestamp = AppLib.getTimestampFromString(`${temp} 00:00:00`)
      if (this.latestMonth < timestamp || timestamp < this.limitMonth) {
        return
      }
      this.month = timestamp
      this.findMonthSummary(AppLib.formatDateFromTimeStamp(this.month))
    },
    // **************** pichart *****************
    customizeLabel (arg) {
      // // console.log(arg.percentText)
      return arg.percentText
    },
    // ***** h-bar *********************
    customizeTooltipHbar (barInfo) {
      let color = this.$_.findIndex(this.pieDataSource, { headName: barInfo.argument })
      color = this.barColor[color]
      return {
        text: '<span style="font-size: 14px; color:#808080">' + barInfo.argument + '</span><br />' +
            '<span style="color: ' + color + ';">' + AppLib.comma((barInfo.originalValue / 1000).toFixed(0)) + '</span>'
      }
    },
    // ***** range select bar *********************
    rangeChange (e) {
      // console.log('rangeChange')
      if (this.isInitSalesRange) {
        this.isInitSalesRange = false
        return
      }
      const changedValue = e.value
      const start = changedValue[0]
      const end = changedValue[1]
      this.index = this.indexMonth = this.indexYear = 0
      // console.log(changedValue)
      let param = {
        fromDate: AppLib.formatDateFromTimeStamp(start.getTime()),
        toDate: `${AppLib.formatDateFromTimeStamp(end.getTime())} 23:59:59`
      }
      // console.log(param)
      this.findYearSalesDailySummary(param)
    },
    rangeChangeProduct (e) {
      // console.log('rangeChangeProduct')
      if (this.isInitProductRange) {
        this.isInitProductRange = false
        return
      }
      const changedValue = e.value
      const start = changedValue[0]
      const end = changedValue[1]
      this.index = this.indexMonth = this.indexYearProduct = 0

      let param = {
        fromDate: AppLib.formatDateFromTimeStamp(start.getTime()),
        toDate: AppLib.formatDateFromTimeStamp(end.getTime())
      }
      this.findYearProductDailySummary(param)
    },
    changeYearSales (offset) {
      if (!this.correctOffset(offset)) {
        return
      }
      this.currentYear += offset
      const param = {
        fromDate: `${this.currentYear}-01-01`,
        toDate: `${this.currentYear}-12-31 23:59:59`
      }
      this.findYearSalesDailySummary(param)
    },
    changeYearProduct (offset) {
      if (!this.correctOffset(offset)) {
        return
      }
      this.currentYearProduct += offset
      const param = {
        fromDate: `${this.currentYearProduct}-01-01`,
        toDate: `${this.currentYearProduct}-12-31 23:59:59`
      }
      this.findYearProductDailySummary(param)
    },
    correctOffset (offset) {
      const neededYear = this.currentYear + offset
      if (neededYear < 2019 || neededYear > this.thisYear) {
        return false
      }
      return true
    }
  }
}

</script>

<style lang="scss">
.header {
  height: 40px;
  padding-left: 50px;
  position: relative;
  h3 {
      line-height: 32px;
      font-weight: 400;
      font-size: 20px;
  }
}
.switcher {
  padding-top: 13px;
  float: right;
  padding-right: 1px;
  .switcher {
    display: inline-block;
    position: relative;
    margin: 0 20px;
    opacity: 0.6;
    font-size: 14px;
    padding-top: 4px;
    line-height: 20px;
    z-index: 1;

    .date {
        display: inline-block;
        width: 100px;
        text-align: center;

        &.day {
            width: 90px;
        }
    }

    .icon {
        cursor: pointer;
        font-size: 20px;
        opacity: 0.6;
        position: absolute;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .dx-icon-spinleft {
        left: -25px;
    }

    .dx-icon-spinright {
        right: -25px;
    }

    .disabled {
        opacity: 0.25;
        cursor: default;
    }
  }
}

.caption {
    padding-bottom: 2px;
    font-weight: 400;
    font-size: 14px;
    opacity: 1.0;
}
.bars {
    height: 275px;
    padding: 0 50px 50px 80px;
    margin: 0 auto;
    min-width: 800px;
    max-width: 1600px;
    .left-bar {
      float: left;
      width: 48%;
      padding-right: 2%;
      .chart {
        clear:both;
        margin-left: 0px;
        min-height:50px;
        width: 106%;
        padding:2px;
        border-radius: 4px;
        border:1px solid rgb(201, 201, 201);
      }
  }

    .right-bar {
      float: left;
      width: 52%;
      padding-left: 2%;
      .chart {
        clear:both;
        margin-left: 0px;
        min-height:50px;
        width: 100%;
        padding:2px;
        border-radius: 4px;
        border:1px solid rgb(201, 201, 201);
      }
  }
}

.gray-line {
    float: left;
    margin:30px 0 0 0;
    background: rgba(150, 150, 150, 0.1);
    padding-bottom:50px;
    min-width: 500px;
    max-width: 800px;
    .title {
      margin: 10px 0 0 10px;
      font-size: 20px;
      font-weight: bold;
    }
}
.line {
  margin-top:6px;
  border-top: 2px solid rgba(150, 150, 150, 0.2);
  padding-left: 1px;
  .parameters-day,.parameters {
    float: left;
    font-size: 14px;
    padding-right: 12px;
    padding-top: 5px;
    padding-bottom: 1px;
    .parameter {
      font-size: 15px;
    }
    .parameter-name {
        opacity: 1.0;

    }
  }
  .parameters-day {
    padding-right: 18px;
  }
}
.sales-by-range {
    height: 280px;
    padding: 10px 10px 0px 20px;
    margin: 0 auto;
    max-width: 800px;
    min-width: 500px;

    .title {
        font-size: 14px;
        opacity: 0.6;
        font-weight: 400;
    }

    .doughnut-container {
        float: left;
        height: 100%;
        width: 30%;
        padding-top:0px;
        .dx-pie-chart {
            height:100%;
        }
    }
    .bar-container {
        height: 100%;
        width: 70%;
        float: right;
        position: relative;
        padding-top: 10px;
       .dx-chart {
            height: 230px;
            padding-top: 10px;
        }
    }
}

.range-selector {
  height: 90px;
  padding: 10px 16px 30px 16px;
  margin: 0 auto;
  max-width: 800px;
  min-width: 800px;
  .container {
    position: relative;
    height: 90px;
    overflow: hidden;

    .icon {
        display: inline-block;
        font-size: 25px;
        opacity: 0.6;
        position: absolute;
        z-index: 1;
        top: 30px;
        cursor: pointer;
        &.disabled {
            cursor: default;
            opacity: 0.25;
        }
    }

    .dx-icon-chevronright {
        right: 0;
    }
  }
}
.temp {
  color: rgb(92, 92, 92);
  color: rgb(57, 133, 248)
}

</style>
